export class Step8 {
  constructor() {}
  intitule = 'stepper.form.commun.divers.step10';
  getspan9 = 'bloc_commun.divers.getspan9';
  getspan10 = 'bloc_commun.divers.getspan10';
  getdatefindiffusion = 'bloc_commun.divers.getdatefindiffusion';
  getobjetavis = 'bloc_commun.divers.getobjetavis';
  getnomorganisme = 'bloc_commun.divers.getnomorganisme';
  getspan11 = 'bloc_commun.divers.getspan11';
  getspan12 = 'bloc_commun.divers.getspan12';
  getcriteressociaux = 'bloc_commun.divers.getcriteressociaux';
  getspan13 = 'bloc_commun.divers.getspan13';
  getcriteresenvironnementaux = 'bloc_commun.divers.getcriteresenvironnementaux';
  getoui = 'bloc_commun.divers.getoui';
  getnon = 'bloc_commun.divers.getnon';
  getmotclef = 'bloc_commun.divers.getmotclef';

}
